export default {
  fastcompany: {
    siteName: 'Fast Company',
    slug: 'fastcompany',
    url: 'https://www.fastcompany.com',
    slogan: 'The future of business',
    description:
      "Fast Company is the world's leading progressive business media brand, with a unique editorial focus on innovation in technology, leadership, and design.",
    favicon: '/favicon.ico',
    logo:
      'https://images.fastcompany.net/image/upload/v1480632834/fast-company-share-graphic.png',
    keywords: [
      'business',
      'magazine',
      'news',
      'leadership',
      'most innovative companies',
      'most creative people',
      'videos',
      'innovation'
    ],
    facebook: {
      fanpageId: '5942134076',
      appId: '178479832213933',
      appAdminId: '100000062710915'
    },
    krux: {
      id: 'J53aqF_f'
    },
    reCaptcha: {
      public: '6Lf59DoUAAAAAMImCMrNJRUIrtlnwN5sH_NOQ9D2'
    },
    omniture: {
      server: 'fastcompany',
      trackingPixel:
        '//grunerandjahr.112.2o7.net/b/ss/gjincfastcoprod/1/H.24.4--NS/0/5658306',
      scode:
        '//images.fastcompany.net/assets/js/vendor/omniture/omniture-scode-prod.js'
    },
    parsely: {
      domain: 'fastcompany.com'
    },
    facebookPixel: {
      id: 475240032660076
    },
    nielsen: {
      clientId: 'us-805310h'
    },
    googleAnalytics: {
      webPropertyId: 'UA-4300461-2',
      rollupPropertyId: 'UA-4300461-33'
    },
    googleAnalyticsIA: {
      webPropertyId: 'UA-4300461-40'
    },
    comscore: {
      c1: 2,
      c2: 6916907,
      publisherId: 6916907
    },
    chartbeat: {
      uid: 2768,
      domain: 'fastcompany.com'
    },
    pingdom: {
      id: '518c1737abe53dc44c000000'
    },
    magazineSubUrls: [
      'https://store.fastcompany.com/subscription-order/singlesku/1999-us'
    ]
  },
  fastcodesign: {
    siteName: 'Co.Design',
    slug: 'fastcodesign',
    url: 'https://www.fastcodesign.com',
    slogan: 'Where business and design collide',
    description:
      'Inspiring stories about innovation and business, seen through the lens of design.',
    favicon: '/favicon.ico',
    logo:
      'https://images.fastcompany.net/image/upload/v1481312788/fcweb/codesign-share-graphic.png',
    keywords: [
      'innovation',
      'ethonomics',
      'graphics',
      'innovation by design',
      'interactive',
      'product',
      'spaces',
      'world changing ideas'
    ],
    facebook: {
      fanpageId: '107619279310824',
      appId: '123388861116012',
      appAdminId: '100000062710915'
    },
    krux: {
      id: 'J53bAWi-'
    },
    omniture: {
      server: 'fastcodesign',
      trackingPixel:
        '//grunerandjahr.112.2o7.net/b/ss/gjincfastcoprod/1/H.24.4--NS/0/5658306',
      scode:
        '//images.fastcompany.net/assets/js/vendor/omniture/omniture-scode-prod.js'
    },
    parsely: {
      domain: 'fastcodesign.com'
    },
    facebookPixel: {
      id: 475240032660076
    },
    nielsen: {
      clientId: 'us-805310h'
    },
    googleAnalytics: {
      webPropertyId: 'UA-4300461-6',
      rollupPropertyId: 'UA-4300461-33'
    },
    googleAnalyticsIA: {
      webPropertyId: 'UA-4300461-41'
    },
    comscore: {
      c1: 2,
      c2: 6916907,
      publisherId: 6916907
    },
    chartbeat: {
      uid: 2768,
      domain: 'fastcodesign.com'
    },
    pingdom: {
      id: '51955434abe53d9a09000000'
    },
    magazineSubUrls: [
      'https://store.fastcompany.com/subscription-order/singlesku/1999-us'
    ]
  }
};



// WEBPACK FOOTER //
// ./src/config/identity.js